import { createSlice } from "@reduxjs/toolkit";
import { categoryApi } from "./categoryApi";

const initialState = {
  data: [],
  isLoading: true,
  error: null,
};

export const categorySlice = createSlice({
  name: "activeCategories",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(categoryApi.fulfilled, (state, action) => {
      state.data = (action.payload?.data || []).map((c) => {
        const { _id, id, ...rest } = c;
        return { id: id || _id, _id: _id, ...rest };
      });
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(categoryApi.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(categoryApi.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.message || "Failed to load categories";
    });
  },
});

export default categorySlice.reducer;
